import * as React from "react";
import {
    Dialog as MuiDialog,
    PaperProps,
    Paper,
    makeStyles,
    createStyles,
} from "@material-ui/core";
import { useDeviceSize } from "..";
import Draggable from "react-draggable";
import { RelodeTheme } from "../styles";

const useDialogStyles = makeStyles(
    (theme: RelodeTheme) =>
        createStyles({
            paper: {
                overflow: "visible",
            },
            paperWidthSm: {
                maxWidth: 650,
            },
        }),
    { name: "Dialog" }
);

export type DialogProps = {
    id?: string;
    children?: React.ReactNode;
    open?: boolean;
    onClose?: () => void;
    maxWidth?: "xs" | "sm" | "md" | "lg" | "xl" | false;
    scroll?: "body" | "paper";
};

export const Dialog = (props: DialogProps) => {
    const { children, open, onClose, maxWidth, id, scroll = "paper" } = props;
    const classes = useDialogStyles(props);

    const device = useDeviceSize();
    const dataCy = props["data-cy"] ?? id ?? "dialog";
    return (
        <MuiDialog
            data-cy={`${dataCy}-dialog`}
            open={open}
            disableBackdropClick={true}
            onClose={onClose}
            fullWidth={device === "desktop"}
            maxWidth={device === "desktop" ? maxWidth ?? "sm" : undefined}
            fullScreen={device === "mobile"}
            scroll={scroll}
            PaperComponent={
                device === "desktop" ? DraggableComponent : undefined
            }
            aria-labelledby="dialog-draggable-content"
            classes={{
                paper: classes.paper,
                paperWidthSm: classes.paperWidthSm,
            }}
        >
            {children}
        </MuiDialog>
    );
};

export const DraggableComponent = (props: PaperProps) => (
    <Draggable handle="#dialog-draggable-content">
        <Paper {...props} />
    </Draggable>
);
